import React from 'react'
import { observer } from 'mobx-react'
import PatientPageStore from '../Store/PatientPageStore'
import {formatDate} from "../../../../utils/utils";





const PatientInfo = observer(
  () => {


    return (
      <div className='patient-page_info page__element' style={{height: 'auto'}}>
	  {/*
        <div className='patient__image'>
          <img src='./userPic.png' alt='' />
        </div>
	  */}
        <div className='patient__name'>{PatientPageStore.patientInfo.fio}</div>
	  {/*
        <div style={{ position: 'relative' }}>
          <button onClick={() => {
            PatientPageStore.showPasswordChangeModal()
          }} className='password-reset'>Изменить пароль
          </button>
          <div onClick={() => {PatientPageStore.showPatientInfoChangeModal()}}
               className='patient__info__edit'>
            <i className='fas fa-pencil-alt' />
          </div>
        </div>
        <div className='patient__info'>
          <div className='patient__info__option'>
            <div className='t'>
              Мед. книжка №
            </div>
            <div>{PatientPageStore.patientInfo.med_book}</div>
          </div>
	  */}
          <div className='patient__info__option' style={{paddingBottom: 20}}>
            <div className='t'>
              Номер телефона
            </div>
            <div>{PatientPageStore.patientInfo.phone}</div>

          </div>
          <div className='patient__info__option' style={{paddingBottom: 20}}>
            <div className='t'>
              Дата рождения
            </div>
            <div>{formatDate(PatientPageStore?.patientInfo?.dob)}</div>
		  </div>
			
          <div className='patient__info__option' style={{paddingBottom: 20}}>
            <div className='t'>
              <button onClick={() => {
				PatientPageStore.showResetPasswordModal()
			  }}>Удалить доступ
			  </button>
            </div>
		  </div>
			
	  {/*

          </div>
          <div className='patient__info__option'>
            <div className='t'>
              СНИЛС
            </div>
            <div>{PatientPageStore.patientInfo.snils}
            </div>

          </div>
          <div className='patient__info__option'>
            <div className='t'>
              Адрес
            </div>
            <div>{PatientPageStore?.patientInfo?.address}</div>
          </div>
	  */}

      </div>
    )
  }
)


export default PatientInfo
